/**
 * ROI/Puck page JSON stores absolute upload URLs from whichever API host uploaded the file.
 * Point /uploads/ paths at the configured API; use relative paths for /static/media/ on the frontend host.
 */
export function rewriteRoiAssetUrls(jsonText, apiBaseUrl) {
  if (!jsonText || typeof jsonText !== 'string') {
    return jsonText;
  }

  const api = (apiBaseUrl || '').replace(/\/$/, '');
  let out = jsonText;

  if (api) {
    out = out.replace(/https?:\/\/[^"'\s]+(\/uploads\/[^"'\s]+)/gi, (_match, uploadPath) => `${api}${uploadPath}`);
  }

  out = out.replace(/https?:\/\/[^"'\s]+(\/static\/media\/[^"'\s]+)/gi, (_match, staticPath) => staticPath);

  return out;
}
